module.exports = __webpack_public_path__ + "static/media/11_tn.da99a6bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/11_tn.jpg
// module id = 149
// module chunks = 0